import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Logo, Spacer, Typography } from '@guildeducationinc/recess';
import KeyboardArrowRightIcon from '@guildeducationinc/recess/icons/KeyboardArrowRightIcon';
import classnames from 'classnames';
import snakeCase from 'lodash/snakeCase';
import { useMediaQuery } from 'react-responsive';
import styles from './FeedbackWidgetBase.module.scss';
import { getCurrentWeglotLocale } from '@src/utilities/weglot';
import { MOBILE_QUERY } from '@src/constants/responsive';
export const FeedbackWidgetBase = ({ user, className, testid = 'feedback-widget', analytics, useSingleColumn = false, }) => {
    const text = "We'd love to know what you think. Tell us about your Guild Experience.";
    const feedbackLinkText = 'Share your feedback';
    const isMobile = useMediaQuery(MOBILE_QUERY);
    const feedbackWidgetContainerClasses = classnames({
        [styles.feedbackWidget__container]: !isMobile && !useSingleColumn,
        [styles.feedbackWidget__containerMobile]: isMobile || useSingleColumn,
    });
    const feedbackWidgetContentClasses = classnames({
        [styles.feedbackWidget__content]: !isMobile && !useSingleColumn,
        [styles.feedbackWidget__contentMobile]: isMobile || useSingleColumn,
    });
    const feedbackWidgetButtonContainerClasses = classnames({
        [styles.feedbackWidget__buttonContainer]: !isMobile && !useSingleColumn,
        [styles.feedbackWidget__buttonContainerMobile]: isMobile || useSingleColumn,
    });
    const feedbackWidgetClasses = classnames([styles.feedbackWidget], className);
    const handleOpeningFeedbackClickable = () => {
        if (window.UserVoice) {
            // Identify user first
            const snakeCaseClientName = snakeCase(user.clientName);
            const anonymizedEmail = `${user.id}+${snakeCaseClientName}@guildfeedback.com`;
            const userVoiceIdentity = {
                email: anonymizedEmail,
                id: user.id,
                account: {
                    id: `global-${user.clientId}`,
                    name: `Global ${user.clientName}`,
                },
            };
            window.UserVoice.push(['identify', userVoiceIdentity]);
            // Set locale
            const weglotLocale = getCurrentWeglotLocale();
            if (weglotLocale) {
                window.UserVoice.push(['set', 'locale', weglotLocale]);
            }
            // Show widget positioned relative to our button
            window.UserVoice.push([
                'show',
                {
                    target: '#feedback-widget__give-feedback-button',
                    mode: 'satisfaction',
                },
            ]);
        }
        if (analytics && analytics.track) {
            analytics.track('Clickable', {
                type: 'link',
                text: 'share_feedback',
                tag: 'uservoice',
                loggedIn: true,
                product: window.location.hostname + window.location.pathname,
            });
        }
    };
    if (user) {
        return (_jsx("div", { "data-testid": testid, className: feedbackWidgetClasses, children: _jsxs("div", { className: feedbackWidgetContainerClasses, children: [_jsxs("div", { className: feedbackWidgetContentClasses, children: [_jsx(Spacer, { pt: 16 }), _jsx(Logo, { alt: "Guild Education", fullLogo: true }), _jsx(Spacer, { pb: 8 }), useSingleColumn && !isMobile ? (_jsxs(_Fragment, { children: [_jsx(Typography, { className: "padding--y_8", variant: "title2", children: text }), _jsx(Spacer, { pb: 8 })] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, { className: "padding--y_8", variant: "title2", children: "We'd love to know what you think." }), _jsx(Typography, { variant: "title2", children: "Tell us about your Guild Experience." }), _jsx(Spacer, { pb: 16 })] }))] }), _jsx("div", { className: feedbackWidgetButtonContainerClasses, children: _jsx("button", { className: styles.feedbackWidget__button, tabIndex: 0, onClick: handleOpeningFeedbackClickable, id: "feedback-widget__give-feedback-button", "aria-label": "Share your feedback", children: _jsxs("span", { className: styles.feedbackWidget__buttonContent, children: [feedbackLinkText, _jsx(KeyboardArrowRightIcon, { size: 24 })] }) }) })] }) }));
    }
    return null;
};
